/**
 * LIGHT DISMISS for the rating card (`<details>` under the stars).
 *
 * A native `<details>` only ever closes from its own `<summary>`: a tap anywhere else on the page leaves
 * the card hanging over the buy box, and that is exactly what the founder hit in the builder
 * (21/09/2026, « quand j'ouvre ça de ratings elle veut plus se fermer ») — she clicked the text above the
 * stars, as anyone closes a popover, and nothing happened. Same behaviour on the live storefront.
 *
 * This layers the three exits every popover has onto the native toggle, which is left untouched (it keeps
 * working with no script at all, and the builder canvas already lets it through):
 *   • a pointer that lands OUTSIDE the card closes it;
 *   • Escape closes it;
 *   • the « read all reviews » link closes it as it scrolls the page to the reviews section — a card left
 *     open over a page that just jumped reads as a bug.
 *
 * `mousedown`, not `click`: the builder canvas stops the propagation of `click` while it selects a block,
 * and a listener bound to `click` would never see that outside press.
 */
export function initRatingPopover(details) {
    const close = () => {
        if (details.open)
            details.open = false;
    };
    const onDocPointer = (e) => {
        if (!details.open)
            return;
        const t = e.target;
        if (t && !details.contains(t))
            close();
    };
    const onKey = (e) => {
        if ((e.key === 'Escape' || e.key === 'Esc') && details.open)
            close();
    };
    const onCtaClick = () => close();
    const cta = details.querySelector('a[href^="#"]');
    document.addEventListener('mousedown', onDocPointer);
    document.addEventListener('keydown', onKey);
    cta?.addEventListener('click', onCtaClick);
    return () => {
        document.removeEventListener('mousedown', onDocPointer);
        document.removeEventListener('keydown', onKey);
        cta?.removeEventListener('click', onCtaClick);
    };
}
//# sourceMappingURL=popoverDismiss.js.map